import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext';
import { useIsDesktop } from '@shared/util/hooks';
import { CustomBatchDesktop } from './CustomBatchDesktop';
import { CustomBatchMobile } from './CustomBatchMobile';

export function CustomBatch(
  props: Pick<Batch, 'rruleOptions' | 'setRruleOptions' | 'setUserIsEditing'>,
) {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return <CustomBatchDesktop {...props} />;
  } else {
    return <CustomBatchMobile {...props} />;
  }
}
